import { OTP_TYPE } from "@/common/const";
import { TRANSACTION_TYPE } from "@/types/transactionType";
import * as userRequest from "@/utils/userRequest";

export default async function sendOTPClaimService(
    token: string,
    claimType: TRANSACTION_TYPE | OTP_TYPE,
    amount: string,
    currency: string,
    key?: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post(
            "auth/send-otp-claim",
            {
                type: claimType,
                amount,
                currency,
                key,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ sendOTPClaimService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
